export default __webpack_public_path__ + "static/media/Excelsior.be6d318d.jpg";